import Blocks from "@/components/Blocks"
import Block from "@/components/wrappers/block"
import styles from "./product-header.module.css"

export default function ProductHeader({ block }) {
  if (block.innerBlocks.length === 0) {
    return null
  }
  return (
    <Block block={block} className={styles.header}>
      <Blocks blocks={block.innerBlocks}></Blocks>
    </Block>
  )
}
